import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { Award, Star, TrendingUp, Shield } from "lucide-react";

const BOARDS = [
  { key: "most_awards", label: "Most Camp Awards", metric: "total", icon: Award, accent: "text-[#E63946]" },
  { key: "most_mvp", label: "Most MVP Awards", metric: "mvp", icon: Star, accent: "text-amber-600" },
  { key: "most_top_prospect", label: "Most Top Prospect", metric: "top_prospect", icon: TrendingUp, accent: "text-[#0A192F]" },
  { key: "most_position_awards", label: "Most Position Awards", metric: "position", icon: Shield, accent: "text-indigo-600" },
];

export default function Awards() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/awards/stats").then(({ data }) => setStats(data)).catch(() => setStats({ total_awards: 0 }));
  }, []);

  return (
    <PublicLayout>
      <section className="bg-[#0A192F] text-white border-b-4 border-[#E63946]">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-14">
          <div className="flex items-center gap-2 label-overline text-[#E63946]"><Award className="w-4 h-4" /> Recognition</div>
          <h1 data-testid="awards-title" className="font-display text-4xl sm:text-6xl uppercase tracking-tighter mt-2">CBR Award Leaders</h1>
          <p className="text-white/60 text-sm mt-3 max-w-2xl">Camp awards accumulate across every CBR ID Camp and showcase — building each prospect's recruiting resume. {stats ? `${stats.total_awards} awards recognized to date.` : ""}</p>
        </div>
      </section>

      <section className="bg-[#F8F9FA] py-12">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 gap-5">
          {BOARDS.map((b) => {
            const rows = (stats && stats[b.key]) || [];
            return (
              <div key={b.key} data-testid={`awards-board-${b.key}`} className="bg-white border border-slate-200 rounded-sm">
                <div className="flex items-center gap-2 px-5 py-3 border-b border-slate-200">
                  <b.icon className={`w-4 h-4 ${b.accent}`} />
                  <h2 className="label-overline text-[#0A192F]">{b.label}</h2>
                </div>
                {rows.length === 0 ? (
                  <p className="p-6 text-sm text-slate-400">No awards published yet.</p>
                ) : (
                  <div>
                    {rows.map((r, i) => (
                      <div key={r.player_id} className="flex items-center gap-3 px-5 py-3 border-t border-slate-50 first:border-0">
                        <span className="font-data text-lg text-slate-400 w-6 text-center">{i + 1}</span>
                        <div className="min-w-0 flex-1">
                          <Link to={`/prospects/${r.player_slug}`} className="font-semibold hover:text-[#E63946] truncate block">{r.player_name}</Link>
                          <div className="text-[11px] text-slate-500">{[r.player_position, r.player_grad_year].filter(Boolean).join(" · ")}</div>
                        </div>
                        <span className={`font-data text-2xl ${b.accent}`}>{r[b.metric]}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
}
